/**
 * Initiële state voor settings
 */
import { combineReducers } from '@ngrx/store';
import { CalendarState } from 'app/core/store/calendar/common/calendar.interface';
import { reducer as ordersReducer } from './orders/calendar-orders.reducer';
import { reducer as relocationsReducer } from './relocations/calendar-relocations.reducer';

export function reducer(state, action: any): CalendarState {
  return combineReducers({
    relocations: relocationsReducer,
    orders: ordersReducer,
  })(state, action);
}
